"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["iconText", "title", "subtitle", "icon", "isMobile"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelFactsItem = function HotelFactsItem(_ref) {
  var _ref$iconText = _ref.iconText,
    iconText = _ref$iconText === void 0 ? '' : _ref$iconText,
    title = _ref.title,
    subtitle = _ref.subtitle,
    icon = _ref.icon,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelFactsItem, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), /*#__PURE__*/_react["default"].createElement(StyledHotelFactsIcon, {
    isMobile: isMobile,
    iconText: iconText
  }, iconText && /*#__PURE__*/_react["default"].createElement("span", null, iconText), icon), /*#__PURE__*/_react["default"].createElement(StyledTexts, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, title), subtitle ? /*#__PURE__*/_react["default"].createElement(StyledSubtitle, null, subtitle) : null));
};
var StyledHotelFactsItem = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledHotelFactsItem",
  componentId: "sc-xlcsf1-0"
})(["display:flex;align-items:start;padding-bottom:20px;"]);
var StyledTexts = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledTexts",
  componentId: "sc-xlcsf1-1"
})(["margin-left:10px;padding-right:10px;flex:100%;"]);
var StyledTitle = _styledComponents["default"].h4.withConfig({
  displayName: "HotelFactsItem__StyledTitle",
  componentId: "sc-xlcsf1-2"
})(["font-style:normal;font-weight:500;", " color:var(--black);"], function (props) {
  return props.isMobile ? (0, _styledComponents.css)(["font-size:14px;line-height:16px;"]) : (0, _styledComponents.css)(["font-size:14px;line-height:16px;"]);
});
var StyledSubtitle = _styledComponents["default"].span.withConfig({
  displayName: "HotelFactsItem__StyledSubtitle",
  componentId: "sc-xlcsf1-3"
})(["font-size:14px;font-style:normal;font-weight:400;line-height:16px;color:var(--black);"]);
var StyledHotelFactsIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledHotelFactsIcon",
  componentId: "sc-xlcsf1-4"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:50%;background-color:var(--background);width:50px;height:50px;span{padding-bottom:2px;}", " ", ""], function (props) {
  return props.iconText && (0, _styledComponents.css)(["display:flex;justify-content:center;flex-direction:column;align-items:center;font-size:14px;"]);
}, function (props) {
  return props.isMobile && (0, _styledComponents.css)(["width:40px;height:40px;svg{transform:scale(0.75);}span{padding-bottom:1px;}"]);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelFactsItem);